<div [style.height.px]="height" class="chart">
    <div class="chart-header">
        <div class="chart-header-title">{{title}}</div>
    </div>
    <div [style.height.px]="height - 60" class="chart-body">
        <table *ngIf="series && series.length > 0" class="chart-body-table">
            <tr class="chart-body-title">
                <td class="chart-body-title-data">{{axisLabel}}</td>
                <td *ngFor="let s of series" class="chart-body-title-series">{{s.name}}</td>
            </tr>

            <tr *ngFor="let label of series[0].dataLabels; let i = index">
                <td class="chart-body-record">
                    <fui-link-button [title]="label"
                                     (click)="selectSingle(i)"></fui-link-button>
                </td>
                <ng-container *ngFor="let s of series">
                    <ng-container [ngSwitch]="s.dataType">
                        <td *ngSwitchCase="'CURRENCY'" class="chart-body-data">
                            {{s.data[i] | wbo_currency}}
                        </td>
                        <td *ngSwitchCase="'PERCENTAGE'" class="chart-body-data">
                            <ng-container *ngIf="s.data[i]">
                                {{s.data[i]}} %
                            </ng-container>
                        </td>
                        <td *ngSwitchCase="'CALCULATED_PERCENTAGE'" class="chart-body-data">
                            <ng-container *ngIf="s.data[i]">
                                {{s.data[i]}} %
                            </ng-container>
                        </td>
                        <td *ngSwitchCase="'SECONDS'" class="chart-body-data">
                            {{s.data[i] | seconds}}
                        </td>
                        <td *ngSwitchDefault class="chart-body-data">
                            {{s.data[i]}}
                        </td>
                    </ng-container>
                </ng-container>
            </tr>
        </table>
    </div>
</div>
